// U-Guarantee-Slider
  document.addEventListener("DOMContentLoaded", function(){
    new Swiper(".guaranteeswiper", {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      pagination: {
        el: ".guaranteeswiper .swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        320: { slidesPerView: 1 },
        769: { slidesPerView: 1 },
        1024: { slidesPerView: 4 }
      }
    });
  });
// U-Reviews
    document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.u-reviews-swiper');
    if(!el) return;
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  });
// U-Announcement-Bar
    document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".announcement-swiper", {
      slidesPerView: 1,              
      centeredSlides: false,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 3,           
          centeredSlides: false,
        }
      }
    });
  });
// U-Image-SLider
document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".u-image-swiper", {
    slidesPerView: 5,
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".u-image-slider .swiper-button-next",
      prevEl: ".u-image-slider .swiper-button-prev",
    },
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      888: {
        slidesPerView: 4,
        spaceBetween: 10,
      },      
      1000: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
  });
});


function toggleProductInCart(checkbox) {
    var productId = checkbox.value;
    console.log('Product ID:', productId);

    if (checkbox.checked) {
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
                id: productId,
                quantity: 1
            },
            dataType: 'json',
            success: function(response) {
                console.log('Added to cart:', response);
                reloadDivContent("mdata-cart-total");
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error adding to cart:', textStatus, XMLHttpRequest.responseJSON);
            }
        });
    } else {
        // Handle removing the product from the cart
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: {
                id: productId,
                quantity: 0
            },
            dataType: 'json',
            success: function(response) {
                console.log('Removed from cart:', response);
                reloadDivContent("mdata-cart-total");
            },
            error: function(XMLHttpRequest, textStatus) {
                console.error('Error removing from cart:', textStatus, XMLHttpRequest.responseJSON);
            }
        });
    }
}

// Reload the content of a div with a specific ID using jQuery
function reloadDivContent(divId) {
  console.log("Reloading Div.....")
  $.get(window.location.href, function(data) {
    var newContent = $(data).find('#' + divId).html();
    $('#' + divId).html(newContent);
  });
  console.log("Reloaded Div.....")
  
}

// Oude 3-seconden-auto-add verwijderd (28-10-2026): raced met het Shipping Protection-script hieronder en zette SP soms 2x in de cart.


// Shipping Protection: standaard aangevinkt in de cart (Nova's, 30-09-2026)
(function () {
  var SP_VARIANT = 50223632875859;
  var OPTOUT_KEY = 'nj_sp_optout';
  var timer = null;
  var busy = false;

  function variantId() {
    var input = document.getElementById('mshipping-toggle-input');
    return input && input.value ? parseInt(input.value, 10) : SP_VARIANT;
  }
  function optedOut() {
    try { return sessionStorage.getItem(OPTOUT_KEY) === '1'; } catch (e) { return false; }
  }
  function setOptOut(value) {
    try { value ? sessionStorage.setItem(OPTOUT_KEY, '1') : sessionStorage.removeItem(OPTOUT_KEY); } catch (e) {}
  }
  function syncToggle(on) {
    document.querySelectorAll('#mshipping-toggle-input').forEach(function (input) { input.checked = on; });
  }
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    if (typeof reloadDivContent === 'function') reloadDivContent('mdata-cart-total');
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Sp-Auto': '1' },
      body: JSON.stringify(body)
    });
  }

  function ensure() {
    if (busy) return;
    busy = true;
    var id = variantId();
    fetch('/cart.js', { headers: { 'X-Sp-Auto': '1' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var sp = cart.items.filter(function (i) { return i.variant_id === id; })[0];
        var others = cart.items.filter(function (i) { return i.variant_id !== id; }).length;
        if (others > 0 && !sp && !optedOut()) {
          return post('/cart/add.js', { items: [{ id: id, quantity: 1 }] }).then(function () { syncToggle(true); refreshCart(); });
        }
        if (sp && (others === 0 || sp.quantity > 1)) {
          return post('/cart/change.js', { id: sp.key, quantity: others === 0 ? 0 : 1 }).then(refreshCart);
        }
        syncToggle(!!sp);
      })
      .catch(function (e) { console.error('Shipping protection:', e); })
      .then(function () { busy = false; });
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(ensure, 400);
  }

  // Klant zet de schakelaar zelf uit: niet opnieuw toevoegen in deze sessie
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'mshipping-toggle-input') setOptOut(!e.target.checked);
  }, true);

  ['theme:cart:change', 'theme:product:added', 'theme:cart:add', 'theme:cart-drawer:open', 'theme:cart-drawer:show'].forEach(function (name) {
    document.addEventListener(name, schedule);
  });

  // Ook toevoegingen via apps (GemPages, bundels) die geen thema-events sturen
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var auto = init && init.headers && init.headers['X-Sp-Auto'];
    var p = nativeFetch.apply(this, arguments);
    if (!auto && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(schedule, schedule);
    }
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
